<div class="auth-page-layout light-theme min-h-screen flex" [class.auth-page-layout-admin]="variant === 'admin'">
  <aside class="auth-hero hidden lg:block relative overflow-hidden">
    <img src="/assets/images/backgrounds/login-hero.jpg" alt="" aria-hidden="true" class="auth-hero-image" />
    <div aria-hidden="true" class="auth-hero-overlay"></div>
    <div class="relative flex flex-col gap-5! max-w-[640px] pt-[152px]! px-16!">
      <h2 class="m-0! text-[44px] leading-[1.15] font-semibold text-[#141414] tracking-[-0.015em]">{{ 'login hero title' | translate }}</h2>
      <div aria-hidden="true" class="w-14 h-[3px] rounded-sm bg-[#5b5f57]"></div>
      <p class="m-0! text-[19px] leading-normal font-semibold text-[#2e2a20] max-w-[420px]">{{ 'login hero subtitle' | translate }}</p>
    </div>
  </aside>

  <main class="auth-main min-w-0 flex flex-col py-6! px-5! sm:px-10!">
    <div class="flex justify-between items-center gap-4! flex-wrap">
      <div class="flex items-center gap-3.5!">
        <a [routerLink]="homeLink" class="block">
          <img src="/assets/images/logos/gfli-light-logo.webp" alt="GFLI – Global Metrics for Sustainable Feed" class="block w-auto h-14" />
        </a>
        @if (variant === 'admin') {
          <span class="auth-badge">Admin</span>
        }
      </div>
      <app-language-dropdown appearance="labeled" [menuClass]="variant === 'admin' ? 'auth-language-menu auth-language-menu-admin' : 'auth-language-menu'" />
    </div>

    <div class="grow flex items-start justify-center pt-10! lg:pt-[72px]! pb-10!">
      <div class="w-full max-w-[420px] flex flex-col gap-6!">
        <ng-content />
      </div>
    </div>
  </main>
</div>
